import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Clear from "@material-ui/icons/Clear";
import {confirmAlert} from "react-confirm-alert";
import {Link} from "react-router-dom";

export default class NewHires extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Temp_Users._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
		this.state.edit_modal = false;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns=[
			{
				Header: "User",
				id: 'name',
				/** @param {Temp_Users_Object} obj */
				accessor: (obj) => obj.name,
				Cell: (props) => {
					let {original} = props;

					return (
						<span>
							<Link to={`/users/${original.user}`}>
								{original.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "ServiceBookr Email",
				id: 'kt3_email',
				/** @param {Temp_Users_Object} obj */
				accessor: obj => obj.kt3_email,
			},
			{
				Header: "Password",
				id: 'daily',
				/** @param {Temp_Users_Object} obj */
				accessor: obj => obj.password,
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 50,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="danger" size={"sm"} block={true} onClick={() => {
							confirmAlert({
								title: 'Confirm Delete',
								message: 'Are you sure you want to remove this user from the temp table? Please make sure their roles are setup correctly in their user profile first.',
								buttons: [
									{
										label: 'Yes',
										onClick: async () => {
											try {
												let model = new API.BuildClass(Types.Temp_Users._name, API.RequestType.DELETE);
												model.object.pkey = props.original.pkey;
												try {
													await model.submit(null, 'DELETE');
												} catch (error) {
												}
												await this.fetchData();
											} catch (error) {
											}
										}
									},
									{
										label: 'No',
										onClick: () => {
										}
									}
								]
							});
						}}>
							<Clear fontSize={'small'}/>
						</Button>
					);
				}
			},

		]
		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
